import { getString } from "../common/common";

export const FILTER_BY = "FILTER_BY";
export const CLEAR_ALL = "CLEAR_ALL";
export const BUT_TYPE = "BUT_TYPE";

export const DEPARTURE_TIME = "DEPARTURE_TIME";
export const SERVICE_CLASS = "SERVICE_CLASS";

export const BOARDING_POINTS = "BOARDING_POINTS";
export const DROPPING_POINTS = "DROPPING_POINTS";
export const PRICE_RANGE = "PRICE_RANGE";
export const MIN_PRICE = "MIN_PRICE";
export const MAX_PRICE = "MAX_PRICE";
export const TO = "TO";

export const translations = {
  en: {
    [FILTER_BY]: "Filter By",
    [CLEAR_ALL]: "Clear All",
    [BUT_TYPE]: "Bus Type",
    [DEPARTURE_TIME]: "Departure Time",
    [SERVICE_CLASS]: "Service Class",
    [BOARDING_POINTS]: "Boarding Points",
    [DROPPING_POINTS]: "Dropping Points",
    [PRICE_RANGE]: "Price Range",
    [MIN_PRICE]: "Min Price",
    [MAX_PRICE]: "Max Price",
    [TO]: "To",
  },
  kn: {
    [FILTER_BY]: "ಮೂಲಕ ಫಿಲ್ಟರ್ ಮಾಡಿ",
    [CLEAR_ALL]: "ತೆರವುಗೊಳಿಸು",
    [BUT_TYPE]: "ಬಸ್ ವರ್ಗ",
    [DEPARTURE_TIME]: "ನಿರ್ಗಮನ ಸಮಯ",
    [SERVICE_CLASS]: "ಸೇವಾ ವರ್ಗ",
    [BOARDING_POINTS]: "ಹತ್ತುವ ಸ್ಥಳಗಳು",
    [DROPPING_POINTS]: "ಇಳಿಯುವ ಸ್ಥಳಗಳು",
    [PRICE_RANGE]: "ಬೆಲೆ ಶ್ರೇಣಿ",
    [MIN_PRICE]: "ಕನಿಷ್ಠ ಬೆಲೆ",
    [MAX_PRICE]: "ಗರಿಷ್ಠ ಬೆಲೆ",
    [TO]: "ಇಲ್ಲಿಗೆ ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
